import React from 'react';

const Settings = () => {
  return (
    <div>
      <h2>Settings</h2>
      <p>Welcome to the Settings page. This is where the user and admin settings will go.</p>
    </div>
  );
};

export default Settings;
